import { Question } from '@phosphor-icons/react';

import {
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from '../ui/Tooltip';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

const TERM_COPY = pt.liabilities.terms;

/**
 * Inline explanation for debt jargon (effort rate, interest, amortization).
 * @param {'effortRate' | 'interest' | 'amortization'} term
 * @param {'icon' | 'label'} variant
 */
export function DebtTermHint({ term, variant = 'icon', className }) {
  const copy = TERM_COPY[term];
  if (!copy) return null;

  const triggerClass =
    variant === 'icon'
      ? cn(
          'inline-flex h-[15px] w-[15px] shrink-0 items-center justify-center rounded-full border border-border text-[9px] font-bold text-muted-foreground transition hover:text-foreground',
          className,
        )
      : cn(
          'inline-flex items-center gap-1 text-[11px] font-semibold text-muted-foreground hover:text-foreground',
          className,
        );

  return (
    <TooltipProvider delayDuration={200}>
      <TooltipRoot>
        <TooltipTrigger asChild>
          <button type="button" className={triggerClass} aria-label={copy.label}>
            {variant === 'icon' ? (
              <Question className="h-2.5 w-2.5" aria-hidden />
            ) : (
              <>
                {copy.label}
                <Question className="h-3.5 w-3.5" aria-hidden />
              </>
            )}
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-[260px] normal-case font-normal tracking-normal"
        >
          {copy.body}
        </TooltipContent>
      </TooltipRoot>
    </TooltipProvider>
  );
}

export default DebtTermHint;
